import React, { useState } from "react";
import { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
    Typography,
    Container,
    Grid,
    Stack,
    Box,
    Tabs,
    Tab,
    Divider,
} from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import Swipeable from "../crm/component/swiper";
import { Variables } from "../../context/VariableContext";
import Page from "../../components/Page";
import CustomButton from "../../components/CustomButton";
import Date from "./seance/date";
import DateList from "./DateList";
import LucideIcon from "../../components/LucideIcon";





// Localizer pour le calendrier
const localizer = momentLocalizer(moment);



const SeanceManagement = () => {
    const [events, setEvents] = useState([]); // Liste des événements
    const [dialogOpen, setDialogOpen] = useState(false); // Gestion de la boîte de dialogue
    const [selectedEvent, setSelectedEvent] = useState(null); // Événement sélectionné
    const [newEventTitle, setNewEventTitle] = useState(""); // Titre du nouvel événement
    const { eventID } = useParams();
    const [view, setView] = useState(1);

    // Ajouter un nouvel événement ou modifier un existant
    const handleSaveEvent = () => {
        if (newEventTitle.trim() === "") return;
        if (selectedEvent.id) {
            // Modification d'un événement existant
            setEvents((prevEvents) =>
                prevEvents.map((event) =>
                    event.id === selectedEvent.id
                        ? { ...event, title: newEventTitle }
                        : event
                )
            );
        } else {
            // Ajout d'un nouvel événement
            setEvents((prevEvents) => [
                ...prevEvents,
                {
                    id: Math.random().toString(36).substr(2, 9), // Générer un ID unique
                    title: newEventTitle,
                    start: selectedEvent.start,
                    end: selectedEvent.end,
                },
            ]);
        }
        setDialogOpen(false);
        setNewEventTitle("");
        setSelectedEvent(null);
    };

    // Supprimer un événement
    const handleDeleteEvent = () => {
        setEvents((prevEvents) =>
            prevEvents.filter((event) => event.id !== selectedEvent.id)
        );
        setDialogOpen(false);
        setSelectedEvent(null);
    };



    // GESTION DE LA MODIFICATION
    const { openDrawer, setOpenDrawer } = Variables();
    const { type, setType } = Variables();

    return (
        <Page title="Séance">
            <Container>
                <Grid container spacing={2} mb={4}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="h3" gutterBottom>
                            Gestion des séances <br />
                            <Typography variant="body2">Créez et modifiez vos séances</Typography>
                        </Typography>
                    </Grid>

                </Grid>

                <Stack justifyContent={'space-between'} direction={'row'} >
                    <Stack direction={'row'} spacing={0}>
                        <Stack direction={'row'} spacing={1} sx={{ borderBottom: view === 0 ? '1px solid #5E17EB' : null, paddingX: 2, color: view === 0 ? '#5E17EB' : null, cursor: 'pointer' }} onClick={() => { setView(0) }}>
                            <LucideIcon name='CalendarDays' />
                            <Typography>Agenda</Typography>
                        </Stack>
                        <Stack direction={'row'} spacing={1} sx={{ borderBottom: view === 1 ? '1px solid #5E17EB' : null, paddingX: 2, color: view === 1 ? '#5E17EB' : null, cursor: 'pointer' }} onClick={() => { setView(1) }}>
                            <LucideIcon name='List' />
                            <Typography>Liste</Typography>
                        </Stack>
                    </Stack>

                    <CustomButton type='primaire' buttonText='Ajouter' component={RouterLink} to="ajout" />

                </Stack>
                <Divider />
                <Box paddingY={2}>
                    {
                        view === 0 ?
                            <Date />
                            : <DateList />
                    }
                </Box>

                <Swipeable type={type} eventID={eventID} date={selectedEvent} />
            </Container>
        </Page>
    );
};

export default SeanceManagement;
